import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../styles/media'

const S = {}

S.Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  touch-action: none;
  z-index: 10000;
  padding: 1.875rem 3.125rem;
  background-color: ${({ customOverlayColor }) =>
    customOverlayColor ? customOverlayColor : `rgba(0, 0, 0, 0.85)`};

  &.modal-transition-enter {
    opacity: 0;

    &-active {
      opacity: 1;
      transition: opacity 0.2s cubic-bezier(0.5, 0, 0.25, 1);
    }
  }

  .modal-transition-exit {
    opacity: 1;

    &-active {
      opacity: 0;
      transition: opacity 0.2s cubic-bezier(0.5, 0, 0.25, 1);
    }
  }

  .modal-body {
    &.storybook-preview-body {
      background: slategrey;
      color: white;
      padding: 1rem;
    }

    position: relative;
    margin: auto;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    min-height: 3.75rem;

    &:focus {
      outline: 0.125rem solid transparent;
      outline-offset: 0.125rem;
      box-shadow: none;
    }
  }

  .modal-close-button {
    position: absolute;
    top: 0;
    cursor: pointer;
    background: none;
    border: none;
    line-height: 0;
    padding: ${({ useCrossIcon }) => (useCrossIcon ? '1.0625rem' : '0.8rem')};

    html:not([dir]) &,
    [dir='ltr'] & {
      right: 0;
      ${({ isCloseInside }) =>
        !isCloseInside &&
        css`
          transform: translate(77%, -77%);
        `};
    }

    [dir='rtl'] & {
      left: 0;
      ${({ isCloseInside }) =>
        !isCloseInside &&
        css`
          transform: translate(-77%, -77%);
        `};
    }

    &:focus {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }

    .circle {
      border-radius: 50%;
      border: 0.125rem solid white;
      width: 0.875rem;
      height: 0.875rem;
      padding: 0.625rem;
      box-sizing: border-box;
    }

    .lines {
      transform: translate(-0.0625rem, -0.0625rem);
    }

    .line {
      position: absolute;
      background: white;
      display: block;
      width: 0.875rem;
      height: 0.125rem;

      &1 {
        top: 0;
        left: 0;
        transform: translateX(-0.375rem) rotate(45deg);
      }

      &2 {
        top: 0;
        right: 0;
        transform: translateX(0.5rem) rotate(-45deg);
      }
    }
  }

  .icon-cross {
    fill: white;

    ${media.md`
      width: 1.5rem;
      height: 1.5rem;
    `};
  }

  .yt-player,
  .embed-player {
    position: relative;
    width: 100%;
    height: 56.25vw;
    min-height: 11.25rem;
    max-height: calc(100vh - 7.5rem);
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`

export default S
